import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "layout-body"
};
const _hoisted_2 = {
  class: "s-table-tool-right",
  style: {
    "text-align": "right",
    "padding-bottom": "10px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_textarea = _resolveComponent("a-textarea");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_col = _resolveComponent("a-col");
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_row = _resolveComponent("a-row");
  const _component_a_form = _resolveComponent("a-form");
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_space = _resolveComponent("a-space");
  return $setup.DMConfig.Model[1] ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
    ref: "RefForm",
    model: $setup.DMConfig.Model,
    "label-col": $setup.DMConfig.DMForm.form.labelCol
  }, {
    default: _withCtx(() => [_createVNode(_component_a_row, {
      gutter: 24,
      style: {
        "padding-top": "30px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_a_col, {
        md: 22,
        sm: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "Model[1].fValue",
          label: "PI提醒模板"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_textarea, {
            type: "text",
            placeholder: "",
            value: $setup.DMConfig.Model[1].fValue,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => $setup.DMConfig.Model[1].fValue = $event),
            allowClear: "true"
          }, null, 8, ["value"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_a_col, {
        md: 22,
        sm: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "Model[2].fValue",
          label: "未上传发票提醒客服邮箱"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            type: "text",
            placeholder: "",
            value: $setup.DMConfig.Model[2].fValue,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => $setup.DMConfig.Model[2].fValue = $event),
            allowClear: "true"
          }, null, 8, ["value"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "label-col"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_a_space, {
    size: 5
  }, {
    default: _withCtx(() => [_createVNode(_component_a_button, {
      type: "primary",
      onClick: $setup.SubmitForm
    }, {
      default: _withCtx(() => [_createTextVNode("保存")]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  })])])) : _createCommentVNode("", true);
}